import { createGlobalStyle, DefaultTheme } from "styled-components";
import convertThemeColorsToRootColors, {
  TThemeColors,
} from "../utils/convertThemeColorsToRootColors";

export const GlobalStyle = createGlobalStyle<{ theme?: DefaultTheme & { colors: TThemeColors } }>`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
    

    *, ::after, ::before {
        box-sizing: border-box;
        font-family: 'Inter', sans-serif;
        padding: 0;
        margin: 0;
    }

    :root {
        --ui-primary-rgb: 238, 126, 5;
        --ui-secondary-rgb: 254,248,236;
        --ui-tertiary-rgb: 0, 144, 118;
        --ui-tertiary-shade-rgb: 21, 104, 89;
        --ui-dark-rgb: 37,37,37;
        --ui-medium-rgb: 54,56,83;
        --ui-light-rgb: 249,249,249;
        --ui-black-rgb: 0,0,0;
        --ui-white-rgb: 255,255,255;
        --ui-success-rgb: 117,216,115;
        --ui-error-rgb: 135,45,45;
        --ui-gray-rgb: 135, 144, 161;
        --ui-warning-rgb: 245, 181, 68;

        --title-size: 1.4rem;
        --subtitle-size: 0.95rem;
        --normal-size: 0.9rem;
        --small-size: 0.8rem;
        
        ${({ theme }: { theme: DefaultTheme & { colors: TThemeColors } }) => {
          return convertThemeColorsToRootColors(theme.colors);
        }}
    }

    a {
        text-decoration: none;
    }
        .uppercase{
            text-transform: uppercase;
        }
`;

export default GlobalStyle;
